/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stout_Mild_Jannes_TasteInputs */

const fr_stout_mild_jannes_taste = /** @type {(inputs: Stout_Mild_Jannes_TasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglages`)
};

/**

* @param {Stout_Mild_Jannes_TasteInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stout_mild_jannes_taste = /** @type {((inputs?: Stout_Mild_Jannes_TasteInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stout_Mild_Jannes_TasteInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stout_mild_jannes_taste(inputs)
});